const DEFAULT_FOCUSABLE = document.querySelectorAll(
  "a[href], button, input, textarea, select, details,[tabindex]:not([tabindex='-1'])"
);
export default (element, focusableElements = DEFAULT_FOCUSABLE) => {
  if (!element)
    throw new Error("Element to trap focus inside not found");
  const firstFocusableElement = [...focusableElements].at(0);
  const lastFocusableElement = [...focusableElements].at(-1);
  const keyboardHandler = (e) => {
    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === firstFocusableElement) {
        e.preventDefault();
        lastFocusableElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    }
  };
  element.addEventListener("keydown", keyboardHandler);
};
